// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Comercial_OrcamentosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/comercial/orcamentos.
 *
 * Per-origem orçamento breakdown with conversion and ticket medio.
 */
import type { Comercial_OrcamentoOrigemRow } from './Comercial_OrcamentoOrigemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Comercial_OrcamentosResponseDados = Comercial_OrcamentoOrigemRow[];

export type Comercial_OrcamentosResponse = ApiResponse<Comercial_OrcamentosResponseDados>;

registerResponseContract('Comercial_OrcamentosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      origem_id:          { type: 'number',  required: false },
      origem_nome:        { type: 'string',  required: false },
      numero_orcamentos:  { type: 'number',  required: false },
      numero_aprovados:   { type: 'number',  required: false },
      valor_total_cents:  { type: 'number',  required: false },
      taxa_conversao:     { type: 'number',  required: false },
      ticket_medio_cents: { type: 'number',  required: false },
    },
  },
})
